import { Box, Paper, Stack, Typography } from "@mui/material";
import { PropsWithChildren, ReactNode } from "react";

export type ChartTooltipProps = PropsWithChildren & {
  title?: ReactNode;
  labels?: {
    color: string;
    value: ReactNode;
  }[];
};

export default function ChartTooltip({
  title,
  labels,
  children,
}: ChartTooltipProps) {
  return (
    <Paper sx={{ p: 1.5 }}>
      {title &&
        (typeof title === "string" ? (
          <Typography variant="body2" fontWeight="800" marginBottom={1}>
            {title}
          </Typography>
        ) : (
          title
        ))}
      {labels?.map((l) => (
        <Stack
          direction="row"
          gap={1}
          alignItems="center"
          key={`${l.color}-${l.value}`}
        >
          <Box
            sx={{
              width: "16px",
              height: "16px",
              borderRadius: "2px",
              backgroundColor: l.color,
            }}
          />
          {typeof l.value === "string" ? (
            <Typography variant="body2">{l.value}</Typography>
          ) : (
            l.value
          )}
        </Stack>
      ))}
      {children}
    </Paper>
  );
}
